import { render, staticRenderFns } from "./FundsOperations.vue?vue&type=template&id=06c6a084&scoped=true&"
import script from "./FundsOperations.vue?vue&type=script&lang=js&"
export * from "./FundsOperations.vue?vue&type=script&lang=js&"
import style0 from "./FundsOperations.vue?vue&type=style&index=0&id=06c6a084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c6a084",
  null
  
)

export default component.exports